import { DEV } from '../constants';

const USER_CURRENT = 'USER_CURRENT'

const setItem = (key, value) => {
  try {
    if (key) {
      return localStorage.setItem(key, JSON.stringify(value));
    }
  } catch (error) {
    if (DEV) {
      console.warn('LocalStorage setItem error: ', error.message);
    }
  }
};

const getItem = (key) => {
  try {
    let result;
    if (key) {
      result = localStorage.getItem(key);
    }
    result = result ? JSON.parse(result) : undefined;
    return result;
  } catch (error) {
    if (DEV) {
      console.warn('LocalStorage getItem error: ', error.message);
    }
  }
};

const removeItem = (key) => {
  try {
    if (key) {
      return localStorage.removeItem(key);
    }
  } catch (error) {
    if (DEV) {
      console.warn('LocalStorage removeItem error: ', error.message);
    }
  }
};

/**
 * Get current user in storage
 */
const getCurrentUser = () => {
  return getItem(USER_CURRENT)
}

/**
 * Set current user in storage
 * @param {*} user_current
 */
const setCurrentUser = (user_current) => {
  setItem(USER_CURRENT, user_current);
}

/**
 * Check if current user is admin or not
 * @returns
 */
const getIsAdmin = () => {
  return [600, 601].includes(getCurrentUser().role_id)
}

const clear = () => {
  return localStorage.clear();
}

export {
  setItem,
  getItem,
  removeItem,
  getCurrentUser,
  setCurrentUser,
  getIsAdmin,
  clear
};
